import React from 'react';
import Icon from '@mdi/react';
import { mdiMenuDown, mdiMenuUp } from '@mdi/js';
import { Typography } from 'antd';
import Ninja from '@ninja';

const { Text } = Typography;

const ChangeIndicator = ({ change }) => {
  if (change === undefined) return null;
  const isNegative = change < 0;

  return (
    <>
      <div className='flex items-center'>
        <Icon
          path={isNegative ? mdiMenuDown : mdiMenuUp}
          color={isNegative ? Ninja.colors.red : Ninja.colors.green}
        />
        <Text
          className='text-sm font-medium'
          style={{ color: isNegative ? Ninja.colors.red : Ninja.colors.green }}
        >
          {change}
        </Text>
      </div>
    </>
  );
};

export default ChangeIndicator;
